import { Outlet } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <>
      <main
        className="flex min-h-screen w-full bg-background justify-between"
        id="main-content"
        tabIndex={-1}
        aria-label="Authentication Main Content"
      >
        <section
          className="relative flex w-full xl:w-1/2 flex-1 flex-col justify-center items-flex-start p-5 xl:px-24 bg-[url(/auth/gradient-blocks.png)] bg-[length:80%] bg-left-top bg-no-repeat justify-center min-h-[700px]"
          aria-label="Authentication Form Section"
        >
          <div className="flex w-full flex-col items-center gap-6 sm:gap-8 h-full justify-center max-w-[480px] m-auto">
            <Outlet />
          </div>
          <div className="flex items-center justify-center w-full pt-2">
            <p className="text-sm font-semibold text-ss-gray-600">
              Powered by SlopeSync
            </p>
          </div>
        </section>

        <aside
          className="hidden ps-0 lg:flex xl:flex xl:w-1/2 2xl:w-1/2 flex-1 items-start gap-2 pe-4 py-4 2xl:pe-6 2xl:py-6 h-screen xl:max-w-[840px]"
          aria-label="Authentication Visual Preview"
          tabIndex={-1}
        >
          <div className="relative w-full h-full min-h-[680px]">
            <div className="relative flex items-center flex-col 2xl:justify-end lg:justify-center md:justify-center h-full">
              <div className="w-full h-full">
                <img
                  src="/auth/auth-image.jpg"
                  alt="Screenshot of the SlopeSync dashboard preview for visual context only."
                  className="w-full h-full rounded-lg max-w-none"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        </aside>
      </main>
    </>
  )
}
